import $ from 'jquery';

function UserProfileInit() {

  $("#img-upload-btn").click(function(){
    var upload = $('input[type=file]');
    upload.change(function(){
      $("#selected-image-name").html($(this).prop("files")[0]['name']);
    });
    upload.click();
    return false;
  });

  $("#save-profile-btn").click(function(){
    $("#profile-form").submit();
  });

  $("#img-remove-btn").click(function(){
    var obj = $("#user_remove");
    var removeCheck = $(this).children("#remove-check");
    var removeTrash = $(this).children("#remove-trash");
    if(obj.prop("checked")){
      obj.prop("checked", false);
      removeCheck.addClass("hidden");
      removeTrash.removeClass("hidden");
    } else {
      obj.prop("checked", true);
      removeCheck.removeClass("hidden");
      removeTrash.addClass("hidden");
    }


  });

}

$(document).ready(function () {
  console.log("frontend: user ready");

  UserProfileInit();
});
